import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useFilterSearchQuery(key: string) {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get(key);

  const updateFilterParam = (values: string) => {
    setSearchParams((prev) => {
      prev.set(key, values);
      return prev;
    });
  };

  const values = useMemo(() => {
    if (!param) return [];
    const items = param.split(',');
    return items.map((item) => item.split(':'));
  }, [param]);

  return { values, updateFilterParam };
}
